import { makeObservable, action, observable } from "mobx";
import { getIntersectionObserverConstructor } from "../../../../helpers";
const defaultsOptions = {
    // root: null,
    rootMargin: "0px",
    threshold: .01
};
//TODO: remove this and use component from shared library that is to be developed - https://jira.dkcorpit.com/browse/SB-24657
//same as dk-same-game-parlay blocks
export class Renderer {
    constructor(props) {
        const _OBS = getIntersectionObserverConstructor();
        this.observer = new _OBS(this.updateOnIdle.bind(this), Object.assign(Object.assign({}, defaultsOptions), props));
        this.isVisible = this.observer["faked"] || false;
        this.idleCallbackID = 0;
        this.onVisibilityChange = props.onVisibilityChange ? props.onVisibilityChange : () => undefined;
        makeObservable(this, {
            isVisible: observable,
            updateVisibility: action
        });
    }
    registerDom(element) {
        this.observer.observe(element);
    }
    unRegisterDom(element) {
        this.observer.unobserve(element);
    }
    updateOnIdle(entries) {
        window.cancelAnimationFrame(this.idleCallbackID);
        this.idleCallbackID = window.requestAnimationFrame(this.updateVisibility.bind(this, entries));
    }
    updateVisibility(entries) {
        const hasVisibleEntry = entries.some(entry => entry.isIntersecting);
        this.isVisible = hasVisibleEntry;
        this.onVisibilityChange(this.isVisible);
    }
}
//# sourceMappingURL=Renderer.js.map